import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';
import { useTranslation } from "react-i18next";

const TemaClase = () => {
  const { promptData, setPromptData} = useActividadesContext();
  const { t } = useTranslation();
  

  const handleTema = (event) => {
    const tema = event.target.value;
   
    setPromptData((prevData) => ({
        ...prevData,
        tema: tema 
      }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
        <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color:'#336B87' }}>
          {t("TemaClaseTitle")}
        </Typography>
        <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>{t("TemaClaseDescription")} </FormLabel>
       
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.tema}
          placeholder={t("TemaClasePlaceholder")}
          onChange={handleTema}
          InputProps={{
            sx: {
                mt:1,
                mb: 3,
                fontFamily: 'montserrat',
                fontSize: '0.75rem',
                color: '#005559',
                '&::placeholder': {
                    color: '#005559',

                },
                '&:before': {
                    borderBottomColor: '#005559',

                },
                '&:after': {
                    borderBottomColor: '#005559',
                },
            }
        }}
        />
      </Box>
    </Grid>
  );
};

export default TemaClase;
